<span [ngClass]="{ 'tw-truncate tw-block': truncate() }">
  <ng-content></ng-content>
</span>
